export const getProjects = (state) => state.projects
export const getProjectsMeta = (state) => state.projectsMeta
export const getProjectReports = (state) => state.projectReports
export const getProjectReportsMeta = (state) => state.projectReportsMeta
export const getProjectsCollection = (state) => state.projectsCollection
export const getProjectStatus = (state) => state.status
export const getBudgetTransactionTypes = (state) => state.transactionTypes
export const getCurrentProject = (state) => state.currentProject
export const getCurrentProjectLogs = (state) => state.currentProjectLogs
export const getCurrentProjectLogsMeta = (state) => state.currentProjectLogsMeta
export const getProjectComments = (state) => (id)  => state.projectComments[id] || []
export const getProjectDirectories = (state) => (id)  => state.projectDirectories[id] || []
export const getReportStatus = (state) => state.report_status
export const getProjectStepTasks = (state) => state.step_tasks
export const getUserPerformCriterias = (state) => state.performCriterias
export const getProjectReactionEnum = (state) => state.projectReactionEnum
export const getProjectEstates = (state) => state.estates
export const getProjectSummaries = (state) => state.summaries
export const getProjectSheetEnum = (state) => state.sheetSummariesEnum
export const getProjectTaskAlertCount = (state) => state.projectsTaskAlertCount